import Activities from './activities.svg';
import Notices from './notices.svg';
import Services from './services.svg';
import Sharing from './sharing.svg';

export { Activities, Notices, Services, Sharing };
